const CONFIG = {
  KEY: process.env.API_KEY,
  BASE_URL: 'https://fuzzy-mag-bidwi-7f3836df.koyeb.app/',
  CACHE_NAME: 'BenahKota-V1',
};

export default CONFIG;
